import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { BusIcon, PlaneIcon } from "./Icons";
import Curve from "../img/curve.png";
import ButtonTheme from "./ButtonTheme";
import OtherVideoLink from "./old-site/OtherVideoLinks2";
import {API_BASE_IMAGES} from "../OldApp";

const About = ({ propertyDetail }) => {
  const downloadBrochure = () => {
    //console.log("brochure", propertyDetail?.brochure?.path);
  };

  return (
    <Box my={20}>
      {/*<Container maxW={{ lg: "60%", base: "90%" }}>
        <Grid
          gridTemplateColumns={{ md: "repeat(2,1fr)", base: "repeat(1,1fr)" }}
          gap={20}
        >
          <GridItem>
            <Flex alignItems={"center"} gap={2} mb={5}>
              <BusIcon w={8} h={8} />{" "}
              <Heading color={"DarkTeal"} fontSize={"2xl"}>
                Bus
              </Heading>
            </Flex>
            <Text color={"DarkTeal"}>
              The nearest bus stop is Fannin St @ McKinney St. It is located at
              287 ft or approximately 1 minutes walk distance.
            </Text>
          </GridItem>
          <GridItem>
            <Flex alignItems={"center"} gap={2} mb={5}>
              <PlaneIcon w={8} h={8} />{" "}
              <Heading color={"DarkTeal"} fontSize={"2xl"}>
                {" "}
                Airport
              </Heading>
            </Flex>
            <Text color={"DarkTeal"}>
              The nearest airport is aeropuerto IHP. It is located 6.4 mi away.
            </Text>
          </GridItem>
        </Grid>
  </Container>*/}
      <Container
        maxW={{ lg: "60%", md: "90%", base: "100%" }}
        px={{ md: 4, base: 0 }}
      >
        <Box
          bgColor={"BrightTurquoise"}
          w={{ md: "96%", base: "100%" }}
          marginLeft={"auto"}
          mt={{ md: 40, base: 20 }}
          p={10}
        >
          <Flex>
            {propertyDetail && propertyDetail.photos && (
              <Box display={{ md: "block", base: "none" }}
                   w={"calc(300px - 100px + 40px)"}
                   flexShrink={"0"}>
                <Box
                    bgImage={API_BASE_IMAGES + propertyDetail?.photos?.[0]?.path_760}
                    bgSize={"cover"}
                    bgPos={"center center"}
                    borderTopLeftRadius={"150px"}
                    h={"300px"}
                    w={"300px"}
                    mt={"-30%"}
                    ms={"-100px"}
                    // TODO - is there a simpler way to do this? We really just want an image square-ish, slightly offset to the northwest.
                />
              </Box>
            )}
            <Box>
              <Text fontSize={"sm"} color={"white"}>
                Property Brochure
              </Text>
              <Heading fontSize={"2xl"} color={"DarkBlue"}>
                {propertyDetail.externalName}
              </Heading>
              <Text my={8} color={"DarkBlue"}>
                Download the brochure now for an in-depth look at the property, location, features, and more.
              </Text>
              <Flex gap={4}>
                {propertyDetail.brochure && propertyDetail.brochure.path && (
                  <a
                    href={API_BASE_IMAGES + propertyDetail?.brochure?.path}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ButtonTheme
                      handleButtonClick={downloadBrochure}
                      btnText={"Download Brochure"}
                      chakraProps={{
                        w: "100%",
                        bgColor: "white",
                        id: "btn_download_brochure"
                      }}
                    />
                  </a>
                )}

        {propertyDetail && propertyDetail.other_videos && (
              <OtherVideoLink property={propertyDetail} />
            )}


              </Flex>
            </Box>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export default About;
